import { Dialog, Fade } from "@mui/material";
import AuthPanel, { AuthMode } from "./AuthPanel";

interface AuthDialogProps {
  open: boolean;
  mode: AuthMode;
  onClose: () => void;
  onSwitch: (mode: AuthMode) => void;
}

/** Mobile-only shell. MUI's Dialog already provides role="dialog",
 *  aria-modal, focus trapping, ESC-to-close, background scroll lock and
 *  scroll restoration, so none of that is reimplemented here. */
const AuthDialog = ({ open, mode, onClose, onSwitch }: AuthDialogProps) => (
  <Dialog
    open={open}
    onClose={onClose}
    fullWidth
    scroll="body"
    TransitionComponent={Fade}
    TransitionProps={{ timeout: 220 }}
    slotProps={{
      backdrop: {
        sx: {
          backgroundColor: "rgba(0, 0, 0, 0.68)",
          backdropFilter: "blur(5px)",
        },
      },
    }}
    PaperProps={{
      sx: {
        m: 0,
        width: "calc(100% - 32px)",
        maxWidth: "420px",
        mx: "auto",
        backgroundColor: "transparent",
        backgroundImage: "none",
        boxShadow: "none",
        overflow: "visible",
        animation: "authDialogRise 220ms ease-out",
        "@keyframes authDialogRise": {
          from: { opacity: 0, transform: "translateY(12px)" },
          to: { opacity: 1, transform: "none" },
        },
      },
    }}
    sx={{
      "& .MuiDialog-container": {
        alignItems: "flex-start",
        pt: "calc(70px + env(safe-area-inset-top))",
        pb: "calc(24px + env(safe-area-inset-bottom))",
      },
    }}
  >
    <AuthPanel mode={mode} onSwitch={onSwitch} onClose={onClose} onSuccess={onClose} />
  </Dialog>
);

export default AuthDialog;
